import { Link, Outlet, createFileRoute, notFound, redirect } from "@tanstack/react-router"
import { Button } from "@/components/ui/button"
import { AppShell } from "@/components/app/app-shell"
import { useWorkspaceFeed } from "@/lib/feed"
import { ApiError } from "@/lib/api"
import { meQuery, rememberWorkspace, workspaceQuery } from "@/lib/queries"

export const Route = createFileRoute("/w/$workspace")({
  beforeLoad: async ({ context, params, location }) => {
    try {
      await context.queryClient.ensureQueryData(meQuery)
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) throw redirect({ to: "/sign-in", search: { redirect: location.href } })
      throw error
    }
    try {
      await context.queryClient.ensureQueryData(workspaceQuery(params.workspace))
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) throw notFound()
      throw error
    }
    rememberWorkspace(params.workspace)
  },
  notFoundComponent: WorkspaceNotFound,
  component: WorkspaceLayout,
})

function WorkspaceLayout() {
  const { workspace } = Route.useParams()
  useWorkspaceFeed(workspace)
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}

function WorkspaceNotFound() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="text-lg font-medium">This workspace isn’t available</h1>
      <p className="max-w-sm text-sm text-muted-foreground">It may have a different address, or you may no longer be a member. Ask an admin for a new invitation if you expected access.</p>
      <Button asChild>
        <Link to="/">Go to your workspaces</Link>
      </Button>
    </div>
  )
}
